import { RefObject, useEffect } from 'react';

function useTrackVisibility(ref: RefObject<HTMLElement>, onVisible: () => void) {
    useEffect(() => {
        if (!ref.current) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    onVisible();

                    // Stop observing after the first trigger
                    observer.unobserve(entry.target);
                }
            },
            // Trigger when 50% of the element is visible
            { threshold: 0.5 }
        );

        observer.observe(ref.current);

        return () => observer.disconnect();
    }, [ref, onVisible]);
}

export default useTrackVisibility;
